import { render, staticRenderFns } from "./BossTable.vue?vue&type=template&id=397f4a7c&scoped=true&"
import script from "./BossTable.vue?vue&type=script&lang=js&"
export * from "./BossTable.vue?vue&type=script&lang=js&"
import style0 from "./BossTable.vue?vue&type=style&index=0&id=397f4a7c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f4a7c",
  null
  
)

export default component.exports